import { useMutation } from '@tanstack/react-query';
import { updateNotificationPreferences } from '../../services/notifications';

interface Options {
  onSuccess?: () => void;
  onError?: () => void;
}

function useUpdateNotificationPreferences({
  onSuccess,
  onError,
}: Options = {}) {
  return useMutation({
    mutationFn: updateNotificationPreferences,
    onSuccess,
    onError,
  });
}

export default useUpdateNotificationPreferences;
